import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoaderCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Label } from '@/components/ui/label'
import IsoDatePicker from '../../schedule/components/IsoDatePicker'
import { todayIso } from '../lib/invoices'

interface Props { open: boolean; onOpenChange: (open: boolean) => void; onConfirm: (paidAt: string) => Promise<boolean> }

/** Ruling Q11: the payment date, today by default; the server refuses one before the issue date. */
const PaidDialog: React.FC<Props> = ({ open, onOpenChange, onConfirm }) => {
  const { t } = useTranslation()
  const [date, setDate] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)
  useEffect(() => { if (open) { setDate(todayIso()); setSubmitting(false) } }, [open])
  const submit = async () => {
    if (!date || submitting) return
    setSubmitting(true)
    const ok = await onConfirm(date)
    setSubmitting(false)
    if (ok) onOpenChange(false)
  }
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!submitting) onOpenChange(next) }}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader><DialogTitle>{t('CostControl_invoice_paid_title')}</DialogTitle></DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="cc-inv-paid">{t('CostControl_invoice_field_paidAt')}</Label>
          <IsoDatePicker id="cc-inv-paid" value={date} onChange={setDate} />
        </div>
        <div className="flex items-center justify-end gap-2 border-t pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={submitting}>{t('Common_cancel')}</Button>
          <Button onClick={submit} disabled={submitting || !date}>
            {submitting && <LoaderCircle className="h-4 w-4 animate-spin" />}
            {t('CostControl_invoice_mark_paid')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default PaidDialog
